import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { UpdateAccessOnAsset } from '../../../../shared/components/permissions/models/updateAccessOnAsset.model';
import { ChangePassword } from '../models/changePassword.model';
import { DeleteUser } from '../models/deleteUser.model';
import { GetUserInfo } from '../models/getUserInfo.model';
import { InviteUser } from '../models/inviteUser.model';
import { UpdateUserInfo } from '../models/updateUserInfo.model';
import { UpdateUserSetting } from '../models/updateUserSetting.model';
import { UpdateMembership } from '../models/updateMembership.mode';
import { GeneralSetting } from '../models/general-setting.model';
import { UsersSetting } from '../models/users-setting.model';
import {User} from '../models/user.model';
import {ConnectionForm} from '../../../../shared/models/connection-form.model';
import {Workspace} from '../../../../shared/models/work-space.model';
import {Connection} from '../models/Connection.model';

@Injectable()
export class ManagementApi {

  baseUrl = environment.baseUrl;
  api = environment.api;

  constructor(private http: HttpClient) {}


  getWorkspaceRoles(workspaceId: string): Observable<any>{
    return this.http.get<any>(`${this.api}/Role/GetWorkspaceRoles/${workspaceId}`);
  }

  getUserInfo(body: GetUserInfo): Observable<any> {
    return this.http.post<any>(`${this.api}/User/GetUserInfo`, body);
  }

  updateUserInfo(body: UpdateUserInfo): Observable<any> {
    return this.http.post(`${this.api}/User/UpdateUserInfo`, body);
  }

  uploadFile(uploadType: string, workspaceId: string, file: File): Observable<any> {
    const body = new FormData();
    body.append('formFile', file, file.name);
    return this.http.post<any>(
      `${this.api}/File/UploadImage/${uploadType}/${workspaceId}`,
      body,
    );
  }

  getUserSetting(workspaceId: string, userId: string): Observable<any> {
    const bodyRequest: GetUserInfo = {
      workspaceId,
      userId,
    };
    return this.http.post<any>(`${this.api}/User/GetUserSetting`, bodyRequest);
  }

  getUserDashboards(userId: string): Observable<any> {
    return this.http.post<any>(`${this.api}/User/GetUserDashboards`, { userId });
  }

  getIPAccessList(userId: string): Observable<any> {
    return this.http.post<any>(`${this.api}/User/GetIPsAccess`, { userId });
  }

  addIPAccess(userId: string, ipAddress: string): Observable<any> {
    return this.http.post<any>(`${this.api}/User/AddIPAccess`, {userId, ipAddress});
  }

  deleteIPAccess(userId: string, ipAddress: string): Observable<any> {
    return this.http.post<any>(`${this.api}/User/DeleteIPAccess`, {userId, ipAddress});
  }

  updateHasIpAccess(userId: string, hasIPAccess: boolean): Observable<any> {
    return this.http.post<any>(`${this.api}/User/UpdateHasIpAccess`, {userId, hasIPAccess});
  }

  updateUserSetting(body: UpdateUserSetting): Observable<any> {
    return this.http.post<any>(`${this.api}/User/UpdateUserSetting`, body);
  }

  changePassword(body: ChangePassword): Observable<any> {
    return this.http.post<any>(`${this.api}/User/ChangePassword`, body);
  }

  getGeneralSettings(): Observable<any> {
    return this.http.get(`${this.api}/ApplicationSetting/GetGeneralSetting`);
  }

  setDefaultGeneralSetting(): Observable<any> {
    return this.http.post(`${this.api}/ApplicationSetting/SetDefaultGeneralSetting`,{});
  }

  getUsersSetting(): Observable<any> {
    return this.http.get(`${this.api}/ApplicationSetting/GetUserSetting`);
  }

  setDefaultUsersSetting(): Observable<any> {
    return this.http.post(`${this.api}/ApplicationSetting/SetDefaultUserSetting`,{});
  }

  getDefaultRelationsSetting(): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/defaultRelationsSetting`);
  }

  getRelationsSetting() {
    return this.http.get(`${this.baseUrl}/api/relationsSetting`);
  }

  getRoles(): Observable<any> {
    return this.http.get(`${this.api}/Role/GetRoles`);
  }

  getUserWorkSpaces(): Observable<any> {
    return this.http.post(`${this.api}/Workspace/GetUserWorkspaces`, {sortOrder: 'None'});
  }
  getWorkspacesWithCreateDashboardGroupPermission(): Observable<any> {
    return this.http.get(`${this.api}/Workspace/GetWorkspacesWithCreateDashboardGroupPermission`);
  }

  getWorkspaces(): Observable<any> {
    return this.http.post(`${this.api}/Workspace/GetWorkspaces`, null);
  }

  getUsersWorkSpace(body): Observable<any> {
    return this.http.post(`${this.api}/User/GetAllUsers`, body);
  }

  getNotApproveUsers(body): Observable<any> {
    return this.http.post(`${this.api}/User/GetNotApproveUsers`, body);
  }

  getWithoutWorkspaceUsers(body): Observable<any> {
    return this.http.post(`${this.api}/User/GetWithoutWorkspaceUsers`, body);
  }

  getAllDeletedUsers(body): Observable<any> {
    return this.http.post(`${this.api}/User/GetAllDeletedUsers`, body);
  }

  getUserGroupsWithUserStatus(bodyRequest: any): Observable<any> {
    return this.http.post(`${this.api}/UserGroup/GetGroupsWithUserStatus`,bodyRequest);
  }

  getAllUserGroups(bodyRequest: any): Observable<any> {
    return this.http.post(`${this.api}/UserGroup/GetAllUserGroups`,bodyRequest);
  }

  getUserAllAccess(body: any): Observable<any> {
    return this.http.post(`${this.api}/User/GetUserAllAccess`,body);
  }

  getUsersInUserGroup(bodyRequest: any): Observable<any> {
    return this.http.post(`${this.api}/UserGroup/GetUsersInGroup`,bodyRequest);
  }

  getActiveIdentitySettings(): Observable<any> {
    return this.http.get<any>(`${this.api}/ApplicationSetting/GetActiveIdentitySettings`, { headers: { skip: 'true' } });
  }

  getUserGroup(workspaceId: string, userGroupId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      userGroupId,
    };
    return this.http.post(`${this.api}/UserGroup/GetUserGroup`,bodyRequest);
  }

  getUserGroupAllAccess(bodyRequest: any): Observable<any> {
    return this.http.post(`${this.api}/UserGroup/GetUserGroupAllAccess`,bodyRequest);
  }

  getUserWorkSpaceMemberships(body: any): Observable<any> {
    return this.http.post(`${this.api}/User/GetUserWorkspaceMembershipStatus`,body);
  }

  updateGeneralSetting(newSetting: GeneralSetting): Observable<any> {
    const body = newSetting;
    body['selectedWorkspaceImagePath'] = newSetting.selectWorkspaceImages.find(img => img.selected === true).filePath;
    return this.http.post(`${this.api}/ApplicationSetting/UpdateGeneralSetting`, body);
  }

  updateUsersSetting(setting: UsersSetting): Observable<any> {
    const tempSetting: any = {...setting};
    tempSetting.loginIds = tempSetting.loginIds.join(',');
    const body: UsersSetting = {
      registerByUser: tempSetting.registerByUser,
      familyRequired: tempSetting.familyRequired,
      mobileRequired: tempSetting.mobileRequired,
      emailRequired: tempSetting.emailRequired,
      nationalCodeRequired: tempSetting.nationalCodeRequired,
      usernameRequired: tempSetting.usernameRequired,
      authenticationType: tempSetting.authenticationType,
      authenticationLevel: tempSetting.authenticationLevel,
      resetPasswordMethod: tempSetting.resetPasswordMethod,
      receiveSMS: tempSetting.receiveSMS,
      loginIds: tempSetting.loginIds,
      refreshTokenDuration: tempSetting.refreshTokenDuration,
      captchaPolicy:tempSetting.captchaPolicy,
      customFields:tempSetting.customFields || [],
      ssoSetting:tempSetting.ssoSetting,
      authenticationProviders:tempSetting.authenticationProviders
    };
    return this.http.post(`${this.api}/ApplicationSetting/UpdateUserSetting`, body);
  }

  updateRelationsSetting(setting: any) {
    return this.http.put(`${this.baseUrl}/api/relationsSetting`, setting);
  }

  updateRole(role: any): Observable<any> {
    const body = {
      name: role.name,
      description: role.description,
      permissions: role.permissions,
      specificRole: true,
    };
    return this.http.post(`${this.api}/Role/UpdateRole/${role.id}`, body);
  }

  setTokenUserDuration(payload: {usersId: string[];tokenDuration: number;allUsers: boolean;allGroupUsers?: boolean}):
    Observable<any> {
    const {allUsers,tokenDuration,usersId, allGroupUsers} = payload;
    const body = {
      allUsers,
      tokenDuration,
      allGroupUsers,
      usersId,
    };
    return this.http.post(`${this.api}/User/SetTokenUserDuration`, body);
  }

  updateTokenDuration(payload: {workspaceId: string;userGroupId: string;refreshTokenDuration: number;
  allGroupUsers?: boolean;}):
    Observable<any> {
    const {workspaceId,userGroupId,refreshTokenDuration, allGroupUsers} = payload;
    const body = {
      workspaceId,
      userGroupId,
      refreshTokenDuration,
      allGroupUsers,
    };
    return this.http.post(`${this.api}/UserGroup/UpdateTokenDuration`, body);
  }

  updateWorkspaceName(workspace: any): Observable<any>  {
    const body = {
      workspaceId: workspace.workspaceId,
      name: workspace.name,
    };
    return this.http.post(`${this.api}/Workspace/UpdateWorkspaceName`,body);
  }

  updateWorkspaceRoles(workspace: any) {
    const tempRoles = [];
    workspace.roles.forEach(role => {
      if(role.isActive) {
        tempRoles.push(role.id);
      }
    });
    const body = {
      workspaceId: workspace.workspaceId,
      roles: tempRoles,
    };
    return this.http.post(`${this.api}/Workspace/UpdateWorkspaceRoles`,body);
  }

  activateWorkspace(workspace: any): Observable<any> {
    return this.http.post(`${this.api}/Workspace/ActivateWorkspace/${workspace.workspaceId}`,{});
  }

  deactivateWorkspace(workspace: any): Observable<any>  {
    return this.http.post(`${this.api}/Workspace/DeactivateWorkspace/${workspace.workspaceId}`,{});
  }

  updateUserGroupName(userGroupId: string, name: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      userGroupId,
      name,
    };
    return this.http.post(`${this.api}/UserGroup/Update`,bodyRequest);
  }

  addUsersToUserGroup(workspaceId: string, userGroupId, users: Partial<User>[]): Observable<any> {
    const userIds = [];
    users.forEach(user => userIds.push(user.userId));
    const bodyRequest = {
      workspaceId,
      userGroupId,
      userIds,
    };
    return this.http.post(`${this.api}/UserGroup/AddUsersToGroup`, bodyRequest);
  }

  updateUserWorkSpaceMemberships(body: UpdateMembership): Observable<any> {
    return this.http.post(`${this.api}/User/UpdateUserWorkspaceMembershipStatus`,body);
  }

  updateUserDashboardAccess(body: UpdateAccessOnAsset): Observable<any> {
    return this.http.post(`${this.api}/User/UpdateDashboardAccess`,body);
  }

  updateUserDataSourceAccess(body: UpdateAccessOnAsset): Observable<any> {
    return this.http.post(`${this.api}/User/UpdateDataSourceAccess`,body);
  }

  updateUserDashboardGroupAccess(body: UpdateAccessOnAsset): Observable<any> {
    return this.http.post(`${this.api}/User/UpdateDashboardGroupAccess`,body);
  }

  deleteRole(roles: any): Observable<any> {
    const body = {
      roles: roles.map(role => role.id),
    };
    return this.http.post(`${this.api}/Role/DeleteRoles`,body);
  }

  deleteUser(body: DeleteUser) {
    return this.http.post(`${this.api}/User/DeleteUser`, body);
  }

  removeUsers(usersIds: string[]): Observable<any> {
    const bodyRequest = {
      usersIds,
    };
    return this.http.post(`${this.api}/User/RemoveUsers`, bodyRequest);
  }

  deleteNotApprovedUser(body: any): Observable<any> {
    return this.http.post(`${this.api}/User/DeleteNotApprovedUsers`, body);
  }
  deleteProfilePhoto(userId: string): Observable<any> {
    const body = {
      userId: userId
    };
    return this.http.post(`${this.api}/User/DeleteProfilePhoto`, body);
  }

  deleteWorkSpace(workSpaceId: any) {
    return this.http.post(`${this.api}/Workspace/DeleteWorkspace/${workSpaceId}`,{});
  }

  deleteUserGroup(userGroupId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      userGroupId,
    };
    return this.http.post(`${this.api}/UserGroup/Delete`,bodyRequest);
  }

  deleteAccess(access: any, userId: any, type: any) {
    const body = {
      workspaceId: access.workspaceId,
      accessId: access.accessId,
      assetId: access.assetId,
      assetType: access.assetsType,
      accessRecipientId: userId,
      userType: type,
    };
    return this.http.post(`${this.api}/User/DeleteAccess`,body);
  }

  deleteUsersOfUserGroup(workspaceId: string, userGroupId: string, userIds: string[]): Observable<any> {
    const bodyRequest = {
      workspaceId,
      userGroupId,
      userIds,
    };
    return this.http.post(`${this.api}/UserGroup/RemoveUsersFromGroup`,bodyRequest);
  }

  restoreUser(userId: string) {
    const body = {
      users: [userId],
    };
    return this.http.post(`${this.api}/User/RestoreUser`, body);
  }

  createRole(role: any): Observable<any> {
    return this.http.post(`${this.api}/Role/CreateRole`, role);
  }

  createWorkSpace(workspace: any): Observable<any> {
    return this.http.post(`${this.api}/Workspace/CreateWorkspace`, workspace);
  }

  inviteUser(user: InviteUser): Observable<any> {
    return this.http.post(`${this.api}/User/InviteUser`, user);
  }

  approveUser(data: any): Observable<any> {
    return this.http.post(`${this.api}/User/ApproveUsers`, data);
  }

  createUserGroup(workspaceId: string, name: string): Observable<any> {
    const bodyRequest= {
      workspaceId,
      name,
    };
    return this.http.post(`${this.api}/UserGroup/CreateNew`, bodyRequest);
  }

  getUsersNotInUserGroup(loadUsers: any): Observable<any> {
    return this.http.post(`${this.api}/UserGroup/GetUsersNotInGroup`, loadUsers);
  }

  getPublicGeneralSettings(): Observable<any>{
    return this.http.get(`${this.api}/ApplicationSetting/GetPublicGeneralSettings`, { headers: { skip: 'true' } });
  }

  updatePhoneNumber(phoneNumber: string, workspaceId: string, userId: string): Observable<any> {
    const bodyRequest = {
      phoneNumber,
      workspaceId,
      userId,
    };
    return this.http.post(`${this.api}/User/UpdatePhoneNumber`, bodyRequest);
  }

  verifyPhoneNumber(otp: string, workspaceId: string, referenceId: string, phoneNumber: string): Observable<any> {
    const bodyRequest = {
      otp,
      referenceId,
      workspaceId,
      phoneNumber,
    };
    return this.http.post(`${this.api}/User/VerifyPhoneNumber`, bodyRequest);
  }

  resendOTP(referenceId: string): Observable<any> {
    const bodyRequest = {
      referenceId,
    };
    return this.http.post(`${this.api}/User/ResendOTP`,bodyRequest);
  }

  getUsersMetadata(workspaceId: string, searchKey?: string): Observable<any> {
    return this.http.post(`${this.api}/User/GetUsersMetadata`, { workspaceId, searchKey });
  }

  getUserGroupMetadata(workspaceId: string, userGroupId: string): Observable<any> {
    return this.http.post(`${this.api}/UserGroup/GetUserGroupMetadata`, { workspaceId, userGroupId });
  }

  getUserAccessMetadata(workspaceId: string, userId: string, searchKey: string): Observable<any> {
    return this.http.post(`${this.api}/User/GetUserAccessMetadata`, { workspaceId, userId, searchKey });
  }

  testDBConnection(connectionForm: Partial<ConnectionForm>): Observable<any> {
    const bodyRequest = {
      name: connectionForm.name,
      dbConnectionType: connectionForm.dbConnectionType,
      serverAddress: connectionForm.serverAddress,
      portNumber: connectionForm.portNumber,
      dbName: connectionForm.dbName,
      windowsAuth: connectionForm.windowsAuth,
      username: connectionForm.username,
      password: connectionForm.password,
    };
      return this.http.post(`${this.api}/DataSource/TestDBConnection`, bodyRequest);
  }

  createDBConnection(connectionForm: Partial<ConnectionForm>): Observable<any> {
    const bodyRequest = {
      name: connectionForm.name,
      dbConnectionType: connectionForm.dbConnectionType,
      serverAddress: connectionForm.serverAddress,
      portNumber: connectionForm.portNumber,
      dbName: connectionForm.dbName,
      windowsAuth: connectionForm.windowsAuth,
      username: connectionForm.username,
      password: connectionForm.password,
    };
    return this.http.post(`${this.api}/DataSource/CreateDBConnection`, bodyRequest);
  }

  updateDBConnection(connectionForm: Partial<ConnectionForm>, id): Observable<any> {
    const bodyRequest = {
      id,
      name: connectionForm.name,
      dbConnectionType: connectionForm.dbConnectionType,
      serverAddress: connectionForm.serverAddress,
      portNumber: connectionForm.portNumber,
      dbName: connectionForm.dbName,
      windowsAuth: connectionForm.windowsAuth,
      username: connectionForm.username,
      password: connectionForm.password,
    };
    return this.http.post(`${this.api}/DataSource/UpdateDBConnection`, bodyRequest);
  }

  getDataBaseConnections(): Observable<any> {
    return this.http.post(`${this.api}/DataSource/GetDBConnections`, {});
  }

  getDataBaseConnection(dbConnectionId: string): Observable<any> {
    return this.http.post(`${this.api}/DataSource/GetDBConnection`, {dbConnectionId});
  }

  getDataBaseConnectionWorkspaces(dbConnectionId: string): Observable<any> {
      return this.http.post(`${this.api}/DataSource/GetDBConnectionWorkspaces`, {dbConnectionId});
  }

  grantDataBaseConnectionAccessToWorkspaces(workspaces: string[], dbConnectionId: string): Observable<any> {
    const bodyRequest = {
      workspaces,
      dbConnectionId,
    };
    return this.http.post(`${this.api}/DataSource/GrantDBConnectionAccessToWorkspaces`, bodyRequest);
  }

  removeDataBaseConnection(dbConnectionId: string): Observable<any> {
    return this.http.post(`${this.api}/DataSource/RemoveDBConnection`, {dbConnectionId});
  }

  changeDataBaseConnectionActivationStatus(dbConnectionId: string, isActive: boolean): Observable<any> {
      const bodyRequest = {
        dbConnectionId,
        isActive,
      };
      return this.http.post(`${this.api}/DataSource/ChangeDBConnectionActivationStatus`, bodyRequest);
  }
  getCustomFields(): Observable<any> {
    return this.http.get(`${this.api}/ApplicationSetting/GetCustomFields`);
  }

  DeleteLogo(): Observable<any> {
    return this.http.get(`${this.api}/ApplicationSetting/DeleteApplicationLogo`)
  }
  
}
